module.exports = __webpack_public_path__ + "account/img/198.4fb93056.png";